import { useState, useEffect, useCallback } from "react";
import { dbGet, dbSet } from "@/lib/db";
import { SK } from "@/lib/constants";

export function useProducts() {
  const [products, setProducts] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dbGet<string[]>(SK.PRODUCTS).then((p) => {
      setProducts(p ?? []);
      setLoading(false);
    });
  }, []);

  const persist = useCallback((next: string[]) => {
    setProducts(next);
    dbSet(SK.PRODUCTS, next);
  }, []);

  const addProduct = useCallback(
    (name: string) => {
      if (!products.includes(name)) persist([...products, name]);
    },
    [products, persist]
  );

  const removeProduct = useCallback(
    (name: string) => {
      persist(products.filter((p) => p !== name));
    },
    [products, persist]
  );

  const setAllProducts = useCallback(
    (p: string[]) => persist(p),
    [persist]
  );

  return { products, loading, addProduct, removeProduct, setAllProducts };
}
